import axios from 'axios';
import axiosInstance from 'config/axiosConfig';
import { CatastroSearchParams, ParcelResultDto, MunicipalityDto, GeometryResultDto } from 'types/Catastro';

class CatastroService {
    /**
     * Search cadastral parcels with advanced filtering
     */
    async searchParcels(params: CatastroSearchParams): Promise<ParcelResultDto[]> {
        try {
            const queryString = new URLSearchParams();

            // Always set areaSearchType to 'total'
            queryString.append('areaSearchType', 'total');

            Object.entries(params).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    if (Array.isArray(value)) {
                        value.forEach((item) => queryString.append(key, item.toString()));
                    } else {
                        queryString.append(key, value.toString());
                    }
                }
            });

            const { data } = await axiosInstance.get(`/catastro/search?${queryString.toString()}`);
            return data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                throw new Error(error.response?.data?.message || 'Error searching parcels');
            }
            throw new Error(error as string);
        }
    }

    /**
     * Get list of all available municipalities
     */
    async getMunicipalities(): Promise<MunicipalityDto[]> {
        try {
            const { data } = await axiosInstance.get('/catastro/municipalities');
            return data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                throw new Error(error.response?.data?.message || 'Error fetching municipalities');
            }
            throw new Error(error as string);
        }
    }

    /**
     * Get geometry coordinates for cadastral references
     */
    async getGeometry(refs: string[]): Promise<GeometryResultDto[]> {
        try {
            const refsParam = refs.join(',');
            const { data } = await axiosInstance.get(`/catastro/geometry?refs=${refsParam}`);
            return data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                throw new Error(error.response?.data?.message || 'Error fetching geometry data');
            }
            throw new Error(error as string);
        }
    }
}

export const catastroService = new CatastroService();
